import React from 'react';

function Etbs() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '40px', backgroundColor: '#f9fafb', marginTop:"3rem" }}>
      {/* Header Section with Animation */}
      <div
        style={{
          background: 'linear-gradient(135deg, #f39c12, #f1c40f)', // Warm gradient background for the heading
          color: '#fff',
          padding: '18px 40px',
          borderRadius: '30px',
          textAlign: 'center',
          fontSize: '40px',
          fontWeight: '600',
          boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
          animation: 'slideIn 1s ease-out', // Slide-in animation
        }}
      >
        ETBS - Efficient Ticket Booking System
      </div>

      {/* Content Section */}
      <div
        style={{
          marginTop: '40px',
          backgroundColor: '#ffffff',
          padding: '25px',
          width: '70%',
          borderRadius: '15px',
          boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.1)',
          color: '#555',
          textAlign: 'left',
          animation: 'fadeIn 2s ease-out', // Fade-in animation
        }}
      >
        <p style={{ fontSize: '18px', lineHeight: '1.8', color: '#333' }}>
          The ETBS (Electronic Ticket Booking System) is designed to streamline the process of booking tickets for various services, events, and transportation. With a user-friendly interface, real-time availability checks, and secure payment options, ETBS makes booking seamless and efficient.
        </p>

        <h4 style={{ color: '#f39c12', fontSize: '22px', fontWeight: '500' }}>What Sets ETBS Apart:</h4>
        <ul style={{ listStyleType: 'circle', marginLeft: '20px', fontSize: '16px' }}>
          <li>Real-time updates on ticket availability and booking status.</li>
          <li>Multiple payment gateway options with secure encryption.</li>
          <li>Optimized user interface for both desktop and mobile devices.</li>
          <li>24/7 customer support through chat or email.</li>
          <li>Easy tracking of booking history and preferences.</li>
        </ul>

        <h4 style={{ color: '#f39c12', fontSize: '22px', fontWeight: '500', marginTop: '20px' }}>Benefits for Users:</h4>
        <p style={{ fontSize: '16px', lineHeight: '1.8', color: '#555' }}>
          ETBS offers numerous benefits to users looking for a quick, efficient, and secure way to book tickets. With a seamless experience across devices and real-time transaction processing, users can book their tickets with ease and confidence, knowing that they are getting the best deals available.
        </p>
      </div>

      {/* Add the CSS animations for the slide-in and fade-in effects */}
      <style>
        {`
          @keyframes slideIn {
            0% { transform: translateY(-60px); opacity: 0; }
            100% { transform: translateY(0); opacity: 1; }
          }

          @keyframes fadeIn {
            0% { opacity: 0; }
            100% { opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}

export default Etbs;
